import styled from '@emotion/styled'

export const ContactPersonsWrapper = styled.div``

export const ContactPersonsTableWrapper = styled.div`
  & > div > div {
    box-shadow: none;
  }
`
